<div class="container">
  <div class="offset-1 col-10">

    <div class=" content">
      <div class=" row">
        <div class=" col-12">
          <div class=" card card-chart">
            <div class=" card-header">
              <div class=" row">
                <div class=" col-sm-6 text-left">
                  <h5 class=" card-category">Target Strategies</h5>
                  <h2 class=" card-title"><i class="fas fa-hard-hat fa-lg"></i>&nbsp;&nbsp;&nbsp; Robustness</h2>
                </div>
                <div class=" col-sm-6">
                  <div class=" btn-group float-right">
                    <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedPage=='rating'}"
                           (click)="selectedPage='rating'">Rating</label>
                    <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedPage=='details'}"
                           (click)="selectedPage='details';selectedTab='Performance'">Details</label>
                    <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedPage=='bootstrapping'}"
                           (click)="selectedPage='bootstrapping';selectedTab2='returns'">Bootstrapping</label>
                  </div>
                </div>
              </div>
            </div>
            <div class=" card-body">
              <div *ngIf="selectedPage=='rating'">
                <!-- Ratings table -->
                <table *ngIf="strategy1 || strategy2 || strategy3" mdbTable small="true">
                  <thead>
                  <tr>
                    <th scope="col" width="30%"></th>
                    <th *ngIf="strategy1" scope="col">{{ strategy1.name }}</th>
                    <th *ngIf="strategy2" scope="col">{{ strategy2.name }}</th>
                    <th *ngIf="strategy3" scope="col">{{ strategy3.name }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th scope="row">Performance</th>
                    <td *ngIf="strategy1" class="rating">
                      <span style="font-size:1.8em" [outerHTML]="strategy1.robustnessAnalysis.conditional_performance.conditional_performance_rating | rating"></span>
                    </td>
                    <td *ngIf="strategy2" class="rating">
                      <span style="font-size:1.8em" [outerHTML]="strategy2.robustnessAnalysis.conditional_performance.conditional_performance_rating | rating"></span>
                    </td>
                    <td *ngIf="strategy3" class="rating">
                      <span style="font-size:1.8em" [outerHTML]="strategy3.robustnessAnalysis.conditional_performance.conditional_performance_rating | rating"></span>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Risk</th>
                    <td *ngIf="strategy1" class="rating">
                      <span style="font-size:1.8em" [outerHTML]="strategy1.robustnessAnalysis.worst_rolling_risk_statistics.worst_rolling_risk_statistics_rating | rating"></span>
                    </td>
                    <td *ngIf="strategy2" class="rating">
                      <span style="font-size:1.8em" [outerHTML]="strategy2.robustnessAnalysis.worst_rolling_risk_statistics.worst_rolling_risk_statistics_rating | rating"></span>
                    </td>
                    <td *ngIf="strategy3" class="rating">
                      <span style="font-size:1.8em" [outerHTML]="strategy3.robustnessAnalysis.worst_rolling_risk_statistics.worst_rolling_risk_statistics_rating | rating"></span>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Outperformance</th>
                    <td *ngIf="strategy1" class="rating">
                      <span style="font-size:1.8em" [outerHTML]="strategy1.robustnessAnalysis.outperformance_probability.outperformance_probability_rating | rating"></span>
                    </td>
                    <td *ngIf="strategy2" class="rating">
                      <span style="font-size:1.8em" [outerHTML]="strategy2.robustnessAnalysis.outperformance_probability.outperformance_probability_rating | rating"></span>
                    </td>
                    <td *ngIf="strategy3" class="rating">
                      <span style="font-size:1.8em" [outerHTML]="strategy3.robustnessAnalysis.outperformance_probability.outperformance_probability_rating | rating"></span>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Global Rating</th>
                    <td *ngIf="strategy1" class="rating">
                      <span style="font-size:1.8em" [outerHTML]="strategy1.robustnessAnalysis.global_robustness_rating | rating"></span>
                    </td>
                    <td *ngIf="strategy2 " class="rating">
                      <span style="font-size:1.8em" [outerHTML]="strategy2.robustnessAnalysis.global_robustness_rating | rating"></span>
                    </td>
                    <td *ngIf="strategy3" class="rating">
                      <span style="font-size:1.8em" [outerHTML]="strategy3.robustnessAnalysis.global_robustness_rating | rating"></span>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <!-- Ratings table -->

                <div class="w-100">
                  <em class="float-right" style="font-size:0.7em">
                    {{ inceptionDate | date:'MMMM d, y' }} — {{ lastDate | date:'MMMM d, y' }}
                  </em>
                </div>
              </div>
              <div *ngIf="selectedPage=='details'">
                <mat-tab-group mat-align-tabs="center" animationDuration="0ms" (selectedTabChange)="onTabChange($event)">
                  <!--    .                                      -->
                  <!--   / \   Do not change mat-tab labels.     -->
                  <!--  / ! \  They are used in typescript code. -->
                  <!-- /_____\                                   -->
                  <mat-tab *ngIf="strategy1 || strategy2 || strategy3" label="Performance"></mat-tab>
                  <mat-tab *ngIf="strategy1 || strategy2 || strategy3" label="Risk"></mat-tab>
                  <mat-tab *ngIf="strategy1 || strategy2 || strategy3" label="Outperformance"></mat-tab>
                </mat-tab-group>

                <br>
                <!-- Conditional Performance bar chart -->
                <app-basic-bar-chart *ngIf="selectedTab=='Performance' && strategy1 && strategy2 && strategy3"
                                     [catNames]="['Market','Sectors','Factors','Overall']"
                                     [catFields]="['market','sectors','factors','overall']"
                                     [series]="[{label: 'default1', name: strategy1.name, values: strategy1.robustnessAnalysis.conditional_performance.global},
                                                {label: 'default2', name: strategy2.name, values: strategy2.robustnessAnalysis.conditional_performance.global},
                                                {label: 'default3', name: strategy3.name, values: strategy3.robustnessAnalysis.conditional_performance.global}]" percent>
                </app-basic-bar-chart>
                <!-- Conditional Performance bar chart -->
                <!-- Rolling Risk Statistics line chart -->
                <div *ngIf="selectedTab=='Risk' && strategy1 && strategy2 && strategy3">
                  <p class="text-center">Volatility</p>
                  <app-basic-line-chart [series]="[{label: 'default1', name: strategy1.name, historical_values: strategy1.robustnessAnalysis.worst_rolling_risk_statistics.volatility.historical_values},
                                                   {label: 'default2', name: strategy2.name, historical_values: strategy2.robustnessAnalysis.worst_rolling_risk_statistics.volatility.historical_values},
                                                   {label: 'default3', name: strategy3.name, historical_values: strategy3.robustnessAnalysis.worst_rolling_risk_statistics.volatility.historical_values}]" percent>
                  </app-basic-line-chart>
                </div>
                <!-- Rolling Risk Statistics line chart -->
                <!-- Outperformance bar chart -->
                <div *ngIf="selectedTab=='Outperformance' && strategy1 && strategy2 && strategy3">
                  <p class="text-center">Over Benchmark</p>
                  <app-basic-bar-chart [catNames]="['1 year','3 years','5 years']"
                                       [catFields]="['rolling_1y','rolling_3y','rolling_5y']"
                                       [series]="[{label: 'default1', name: strategy1.name, values: strategy1.robustnessAnalysis.outperformance_probability.over_benchmark},
                                                  {label: 'default2', name: strategy2.name, values: strategy2.robustnessAnalysis.outperformance_probability.over_benchmark},
                                                  {label: 'default3', name: strategy3.name, values: strategy3.robustnessAnalysis.outperformance_probability.over_benchmark}]" percent>
                  </app-basic-bar-chart>
                </div>
                <!-- Outperformance bar chart -->
              </div>
              <div *ngIf="selectedPage=='bootstrapping'">
                <mat-tab-group mat-align-tabs="center" animationDuration="0ms" (selectedTabChange)="onTab2Change($event)">
                  <!--    .                                      -->
                  <!--   / \   Do not change mat-tab labels.     -->
                  <!--  / ! \  They are used in typescript code. -->
                  <!-- /_____\                                   -->
                  <mat-tab *ngIf="strategy1 || strategy2 || strategy3" label="Returns"></mat-tab>
                  <mat-tab *ngIf="strategy1 || strategy2 || strategy3" label="Volatility"></mat-tab>
                </mat-tab-group>

                <br>
                <!-- Simulation Returns Density chart -->
                <div *ngIf="selectedTab2=='returns' && strategy1 && strategy2 && strategy3">
                  <app-basic-bar-chart [series]="[{label: 'default1', name: strategy1.name, values: strategy1.robustnessAnalysis.simulation.bootstrapping.three_years.returns_density},
                                                  {label: 'default2', name: strategy2.name, values: strategy2.robustnessAnalysis.simulation.bootstrapping.three_years.returns_density},
                                                  {label: 'default3', name: strategy3.name, values: strategy3.robustnessAnalysis.simulation.bootstrapping.three_years.returns_density}]" percent>
                  </app-basic-bar-chart>
                </div>
                <!-- Simulation Returns Density chart -->

                <!-- Simulation Volatility Density chart -->
                <div *ngIf="selectedTab2=='volatility' && strategy1 && strategy2 && strategy3">
                  <app-basic-bar-chart [series]="[{label: 'default1', name: strategy1.name, values: strategy1.robustnessAnalysis.simulation.bootstrapping.three_years.volatility_density},
                                                  {label: 'default2', name: strategy2.name, values: strategy2.robustnessAnalysis.simulation.bootstrapping.three_years.volatility_density},
                                                  {label: 'default3', name: strategy3.name, values: strategy3.robustnessAnalysis.simulation.bootstrapping.three_years.volatility_density}]" percent>
                  </app-basic-bar-chart>
                </div>
                <!-- Simulation Volatility Density chart -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="selectedPage=='details'" class=" content">
        <br>
        <div class=" row">
          <div class=" col-12">
            <div class=" card card-chart">
              <div class=" card-header">
                <div class=" row">
                  <div class=" col-12 text-center">
                    <h2 class=" card-title"><span *ngIf="selectedPage=='details'">{{ selectedTab }}</span></h2>
                  </div>
                </div>
              </div>
              <div class=" card-body">
                <div *ngIf="selectedPage=='details'">
                  <!-- Conditional Performance table -->
                  <table *ngIf="selectedTab=='Performance'" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="30%"></th>
                      <th *ngIf="strategy1" scope="col">{{ strategy1.name }}</th>
                      <th *ngIf="strategy2" scope="col">{{ strategy2.name }}</th>
                      <th *ngIf="strategy3" scope="col">{{ strategy3.name }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <th scope="row">Market</th>
                      <td *ngIf="strategy1">{{ strategy1.robustnessAnalysis.conditional_performance.global.market | percent:'.1' }}</td>
                      <td *ngIf="strategy2">{{ strategy2.robustnessAnalysis.conditional_performance.global.market | percent:'.1' }}</td>
                      <td *ngIf="strategy3">{{ strategy3.robustnessAnalysis.conditional_performance.global.market | percent:'.1' }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Sectors</th>
                      <td *ngIf="strategy1">{{ strategy1.robustnessAnalysis.conditional_performance.global.sectors | percent:'.1' }}</td>
                      <td *ngIf="strategy2">{{ strategy2.robustnessAnalysis.conditional_performance.global.sectors | percent:'.1' }}</td>
                      <td *ngIf="strategy3">{{ strategy3.robustnessAnalysis.conditional_performance.global.sectors | percent:'.1' }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Factors</th>
                      <td *ngIf="strategy1">{{ strategy1.robustnessAnalysis.conditional_performance.global.factors | percent:'.1' }}</td>
                      <td *ngIf="strategy2">{{ strategy2.robustnessAnalysis.conditional_performance.global.factors | percent:'.1' }}</td>
                      <td *ngIf="strategy3">{{ strategy3.robustnessAnalysis.conditional_performance.global.factors | percent:'.1' }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Overall</th>
                      <td *ngIf="strategy1">{{ strategy1.robustnessAnalysis.conditional_performance.global.overall | percent:'.1' }}</td>
                      <td *ngIf="strategy2">{{ strategy2.robustnessAnalysis.conditional_performance.global.overall | percent:'.1' }}</td>
                      <td *ngIf="strategy3">{{ strategy3.robustnessAnalysis.conditional_performance.global.overall | percent:'.1' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Conditional Performance table -->

                  <!-- Rolling Risk Statistics table -->
                  <table *ngIf="selectedTab=='Risk'" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="30%"><em class="float-left"></em></th>
                      <th *ngIf="strategy1" scope="col">{{ strategy1.name }}</th>
                      <th *ngIf="strategy2" scope="col">{{ strategy2.name }}</th>
                      <th *ngIf="strategy3" scope="col">{{ strategy3.name }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <th scope="row">Volatility</th>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <th class="text-right" style="color: grey"><em>Inception</em></th>
                      <td *ngIf="strategy1">{{ strategy1.robustnessAnalysis.worst_rolling_risk_statistics.volatility.inception | percent:'.1' }}</td>
                      <td *ngIf="strategy2">{{ strategy2.robustnessAnalysis.worst_rolling_risk_statistics.volatility.inception | percent:'.1' }}</td>
                      <td *ngIf="strategy3">{{ strategy3.robustnessAnalysis.worst_rolling_risk_statistics.volatility.inception | percent:'.1' }}</td>
                    </tr>
                    <tr>
                      <th class="text-right" style="color: grey"><em>Worst 5%</em></th>
                      <td *ngIf="strategy1">{{ strategy1.robustnessAnalysis.worst_rolling_risk_statistics.volatility.worst_5pct | percent:'.1' }}</td>
                      <td *ngIf="strategy2">{{ strategy2.robustnessAnalysis.worst_rolling_risk_statistics.volatility.worst_5pct | percent:'.1' }}</td>
                      <td *ngIf="strategy3">{{ strategy3.robustnessAnalysis.worst_rolling_risk_statistics.volatility.worst_5pct | percent:'.1' }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Tracking Error</th>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <th class="text-right" style="color: grey"><em>Inception</em></th>
                      <td *ngIf="strategy1">{{ strategy1.robustnessAnalysis.worst_rolling_risk_statistics.tracking_error.inception | percent:'.1' }}</td>
                      <td *ngIf="strategy2">{{ strategy2.robustnessAnalysis.worst_rolling_risk_statistics.tracking_error.inception | percent:'.1' }}</td>
                      <td *ngIf="strategy3">{{ strategy3.robustnessAnalysis.worst_rolling_risk_statistics.tracking_error.inception | percent:'.1' }}</td>
                    </tr>
                    <tr>
                      <th class="text-right" style="color: grey"><em>Worst 5%</em></th>
                      <td *ngIf="strategy1">{{ strategy1.robustnessAnalysis.worst_rolling_risk_statistics.tracking_error.worst_5pct | percent:'.1' }}</td>
                      <td *ngIf="strategy2">{{ strategy2.robustnessAnalysis.worst_rolling_risk_statistics.tracking_error.worst_5pct | percent:'.1' }}</td>
                      <td *ngIf="strategy3">{{ strategy3.robustnessAnalysis.worst_rolling_risk_statistics.tracking_error.worst_5pct | percent:'.1' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Rolling Risk Statistics table -->

                  <!-- Outperformance Probability table -->
                  <table *ngIf="selectedTab=='Outperformance'" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="20%"></th>
                      <th></th>
                      <th *ngIf="strategy1" scope="col">{{ strategy1.name }}</th>
                      <th *ngIf="strategy2" scope="col">{{ strategy2.name }}</th>
                      <th *ngIf="strategy3" scope="col">{{ strategy3.name }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <th scope="row">Over Benchmark</th>
                      <th scope="row" style="color: grey"><em>1 year</em></th>
                      <td *ngIf="strategy1">{{ strategy1.robustnessAnalysis.outperformance_probability.over_benchmark.rolling_1y | percent:'.1' }}</td>
                      <td *ngIf="strategy2">{{ strategy2.robustnessAnalysis.outperformance_probability.over_benchmark.rolling_1y | percent:'.1' }}</td>
                      <td *ngIf="strategy3">{{ strategy3.robustnessAnalysis.outperformance_probability.over_benchmark.rolling_1y | percent:'.1' }}</td>
                    </tr>
                    <tr>
                      <td></td>
                      <th scope="row" style="color: grey"><em>3 years</em></th>
                      <td *ngIf="strategy1">{{ strategy1.robustnessAnalysis.outperformance_probability.over_benchmark.rolling_3y | percent:'.1' }}</td>
                      <td *ngIf="strategy2">{{ strategy2.robustnessAnalysis.outperformance_probability.over_benchmark.rolling_3y | percent:'.1' }}</td>
                      <td *ngIf="strategy3">{{ strategy3.robustnessAnalysis.outperformance_probability.over_benchmark.rolling_3y | percent:'.1' }}</td>
                    </tr>
                    <tr>
                      <td></td>
                      <th scope="row" style="color: grey"><em>5 years</em></th>
                      <td *ngIf="strategy1">{{ strategy1.robustnessAnalysis.outperformance_probability.over_benchmark.rolling_5y | percent:'.1' }}</td>
                      <td *ngIf="strategy2">{{ strategy2.robustnessAnalysis.outperformance_probability.over_benchmark.rolling_5y | percent:'.1' }}</td>
                      <td *ngIf="strategy3">{{ strategy3.robustnessAnalysis.outperformance_probability.over_benchmark.rolling_5y | percent:'.1' }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Over Risk-Free</th>
                      <th scope="row" style="color: grey"><em>1 year</em></th>
                      <td *ngIf="strategy1">{{ strategy1.robustnessAnalysis.outperformance_probability.over_risk_free.rolling_1y | percent:'.1' }}</td>
                      <td *ngIf="strategy2">{{ strategy2.robustnessAnalysis.outperformance_probability.over_risk_free.rolling_1y | percent:'.1' }}</td>
                      <td *ngIf="strategy3">{{ strategy3.robustnessAnalysis.outperformance_probability.over_risk_free.rolling_1y | percent:'.1' }}</td>
                    </tr>
                    <tr>
                      <td></td>
                      <th scope="row" style="color: grey"><em>3 years</em></th>
                      <td *ngIf="strategy1">{{ strategy1.robustnessAnalysis.outperformance_probability.over_risk_free.rolling_3y | percent:'.1' }}</td>
                      <td *ngIf="strategy2">{{ strategy2.robustnessAnalysis.outperformance_probability.over_risk_free.rolling_3y | percent:'.1' }}</td>
                      <td *ngIf="strategy3">{{ strategy3.robustnessAnalysis.outperformance_probability.over_risk_free.rolling_3y | percent:'.1' }}</td>
                    </tr>
                    <tr>
                      <td></td>
                      <th scope="row" style="color: grey"><em>5 years</em></th>
                      <td *ngIf="strategy1">{{ strategy1.robustnessAnalysis.outperformance_probability.over_risk_free.rolling_5y | percent:'.1' }}</td>
                      <td *ngIf="strategy2">{{ strategy2.robustnessAnalysis.outperformance_probability.over_risk_free.rolling_5y | percent:'.1' }}</td>
                      <td *ngIf="strategy3">{{ strategy3.robustnessAnalysis.outperformance_probability.over_risk_free.rolling_5y | percent:'.1' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Outperformance Probability table -->

                  <div class="w-100">
                    <em class="float-right" style="font-size:0.7em">
                      {{ inceptionDate | date:'MMMM d, y' }} — {{ lastDate | date:'MMMM d, y' }}
                    </em>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="selectedPage=='bootstrapping'" class=" content">
        <br>
        <div *ngIf="selectedTab2=='returns'" class=" card card-chart">
          <div class=" card-header">
            <div class=" row">
              <div class=" col-12 text-center">
                <h2 class=" card-title"><span>Bootstrapping</span></h2>
              </div>
            </div>
          </div>
          <div class=" card-body">
            <!-- Simulation table -->
            <table *ngIf="strategy1 || strategy2 || strategy3" mdbTable small="true">
              <thead>
              <tr>
                <th scope="col" width="20%"></th>
                <th></th>
                <th *ngIf="strategy1" scope="col">{{ strategy1.name }}</th>
                <th *ngIf="strategy2" scope="col">{{ strategy2.name }}</th>
                <th *ngIf="strategy3" scope="col">{{ strategy3.name }}</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <th scope="row">Returns</th>
                <th scope="row" style="color: grey"><em>Proba. > 5%</em></th>
                <td *ngIf="strategy1">{{ strategy1.robustnessAnalysis.simulation.bootstrapping.three_years.returns_distribution.probability_5pct | percent:'.1' }}</td>
                <td *ngIf="strategy2">{{ strategy2.robustnessAnalysis.simulation.bootstrapping.three_years.returns_distribution.probability_5pct | percent:'.1' }}</td>
                <td *ngIf="strategy3">{{ strategy3.robustnessAnalysis.simulation.bootstrapping.three_years.returns_distribution.probability_5pct | percent:'.1' }}</td>
              </tr>
              <tr>
                <td></td>
                <th scope="row" style="color: grey"><em>Proba. > 50%</em></th>
                <td *ngIf="strategy1">{{ strategy1.robustnessAnalysis.simulation.bootstrapping.three_years.returns_distribution.probability_50pct | percent:'.1' }}</td>
                <td *ngIf="strategy2">{{ strategy2.robustnessAnalysis.simulation.bootstrapping.three_years.returns_distribution.probability_50pct | percent:'.1' }}</td>
                <td *ngIf="strategy3">{{ strategy3.robustnessAnalysis.simulation.bootstrapping.three_years.returns_distribution.probability_50pct | percent:'.1' }}</td>
              </tr>
              <tr>
                <td></td>
                <th scope="row" style="color: grey"><em>Proba. > 95%</em></th>
                <td *ngIf="strategy1">{{ strategy1.robustnessAnalysis.simulation.bootstrapping.three_years.returns_distribution.probability_95pct | percent:'.1' }}</td>
                <td *ngIf="strategy2">{{ strategy2.robustnessAnalysis.simulation.bootstrapping.three_years.returns_distribution.probability_95pct | percent:'.1' }}</td>
                <td *ngIf="strategy3">{{ strategy3.robustnessAnalysis.simulation.bootstrapping.three_years.returns_distribution.probability_95pct | percent:'.1' }}</td>
              </tr>
              </tbody>
            </table>
            <!-- Simulation table -->

            <div class="w-100">
              <em class="float-right" style="font-size:0.7em">
                {{ inceptionDate | date:'MMMM d, y' }} — {{ lastDate | date:'MMMM d, y' }}
              </em>
            </div>
          </div>
        </div>

        <div *ngIf="selectedTab2=='volatility'" class=" card card-chart">
          <div class=" card-header">
            <div class=" row">
              <div class=" col-12 text-center">
                <h2 class=" card-title"><span>Bootstrapping</span></h2>
              </div>
            </div>
          </div>
          <div class=" card-body">
            <!-- Simulation table -->
            <table *ngIf="strategy1 || strategy2 || strategy3" mdbTable small="true">
              <thead>
              <tr>
                <th scope="col" width="20%"></th>
                <th></th>
                <th *ngIf="strategy1" scope="col">{{ strategy1.name }}</th>
                <th *ngIf="strategy2" scope="col">{{ strategy2.name }}</th>
                <th *ngIf="strategy3" scope="col">{{ strategy3.name }}</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <th scope="row">Volatility</th>
                <th scope="row" style="color: grey"><em>Proba. > 5%</em></th>
                <td *ngIf="strategy1">{{ strategy1.robustnessAnalysis.simulation.bootstrapping.three_years.volatility_distribution.probability_5pct | percent:'.1' }}</td>
                <td *ngIf="strategy2">{{ strategy2.robustnessAnalysis.simulation.bootstrapping.three_years.volatility_distribution.probability_5pct | percent:'.1' }}</td>
                <td *ngIf="strategy3">{{ strategy3.robustnessAnalysis.simulation.bootstrapping.three_years.volatility_distribution.probability_5pct | percent:'.1' }}</td>
              </tr>
              <tr>
                <td></td>
                <th scope="row" style="color: grey"><em>Proba. > 50%</em></th>
                <td *ngIf="strategy1">{{ strategy1.robustnessAnalysis.simulation.bootstrapping.three_years.volatility_distribution.probability_50pct | percent:'.1' }}</td>
                <td *ngIf="strategy2">{{ strategy2.robustnessAnalysis.simulation.bootstrapping.three_years.volatility_distribution.probability_50pct | percent:'.1' }}</td>
                <td *ngIf="strategy3">{{ strategy3.robustnessAnalysis.simulation.bootstrapping.three_years.volatility_distribution.probability_50pct | percent:'.1' }}</td>
              </tr>
              <tr>
                <td></td>
                <th scope="row" style="color: grey"><em>Proba. > 95%</em></th>
                <td *ngIf="strategy1">{{ strategy1.robustnessAnalysis.simulation.bootstrapping.three_years.volatility_distribution.probability_95pct | percent:'.1' }}</td>
                <td *ngIf="strategy2">{{ strategy2.robustnessAnalysis.simulation.bootstrapping.three_years.volatility_distribution.probability_95pct | percent:'.1' }}</td>
                <td *ngIf="strategy3">{{ strategy3.robustnessAnalysis.simulation.bootstrapping.three_years.volatility_distribution.probability_95pct | percent:'.1' }}</td>
              </tr>
              </tbody>
            </table>
            <!-- Simulation table -->

            <div class="w-100">
              <em class="float-right" style="font-size:0.7em">
                {{ inceptionDate | date:'MMMM d, y' }} — {{ lastDate | date:'MMMM d, y' }}
              </em>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
